module.exports = __webpack_public_path__ + "static/media/shop.4babf6db.png";